export const LocalStorageConstants = {
  OKTA_TOKEN: "okta-token-storage",
  SPECIAL_LINK_TRACKER_FILTERS: "special-link-tracker-filters",
};
